import React, { useMemo, useState } from "react";
import {
  Alert,
  Breadcrumb,
  Button,
  Input,
  InputNumber,
  Select,
  Space,
  Table,
  Tooltip,
  Divider
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import "../../../styles/Main.scss";
import SearchIcon from "../../../image/SearchIcon.svg";

const { Search } = Input;

const PROJECTS = [
  { label: "Gota Residential", value: "Gota Residential" },
  { label: "Apex Business Park", value: "Apex Business Park" },
];

const UNIT_TYPES = [
  { label: "2BHK Flat – Type A", value: "2BHK Flat – Type A" },
  { label: "3BHK Flat – Type B", value: "3BHK Flat – Type B" },
];

const WINGS = [
  { label: "Wing D", value: "Wing D" },
  { label: "Wing E", value: "Wing E" },
  { label: "Wing F", value: "Wing F" },
];

const MASTER_ITEMS = [
  { key: "Tap", name: "Tap", uom: "Nos" },
  { key: "Ceiling Fan", name: "Ceiling Fan", uom: "Nos" },
  { key: "LED Tube Light", name: "LED Tube Light", uom: "Nos" },
  { key: "Switch Board (8M)", name: "Switch Board (8M)", uom: "Nos" },
];

const UnitMaterialStandardBOM = () => {
  const [project, setProject] = useState("Gota Residential");
  const [unitType, setUnitType] = useState("2BHK Flat – Type A");
  const [applicableFor, setApplicableFor] = useState(["Wing D", "Wing E"]);

  const [itemSearch, setItemSearch] = useState("");
  const [selectedItemKey, setSelectedItemKey] = useState(null);
  const [stdQty, setStdQty] = useState(undefined);

  const [standardList, setStandardList] = useState([
    { key: "Tap", itemName: "Tap", qty: 4, uom: "Nos" },
    { key: "Ceiling Fan", itemName: "Ceiling Fan", qty: 3, uom: "Nos" },
    { key: "LED Tube Light", itemName: "LED Tube Light", qty: 6, uom: "Nos" },
  ]);

  const filteredMasterItems = useMemo(() => {
    if (!itemSearch) return MASTER_ITEMS;
    return MASTER_ITEMS.filter((i) =>
      i.name.toLowerCase().includes(itemSearch.toLowerCase())
    );
  }, [itemSearch]);

  const addToList = () => {
    const item = MASTER_ITEMS.find((i) => i.key === selectedItemKey);
    if (!item || !stdQty) return;

    setStandardList((prev) => {
      const exists = prev.find((r) => r.key === item.key);
      if (exists) {
        return prev.map((r) =>
          r.key === item.key ? { ...r, qty: stdQty } : r
        );
      }
      return [...prev, { key: item.key, itemName: item.name, qty: stdQty, uom: item.uom }];
    });

    setSelectedItemKey(null);
    setStdQty(undefined);
    setItemSearch("");
  };

  const removeRow = (key) => {
    setStandardList((prev) => prev.filter((r) => r.key !== key));
  };

  const columns = [
    { title: "Item Name", dataIndex: "itemName", key: "itemName" },
    {
      title: "Standard Qty",
      key: "qty",
      width: 180,
      render: (_, record) => `${record.qty} ${record.uom}`,
    },
    {
      title: "Action",
      key: "action",
      width: 90,
      render: (_, record) => (
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={() => removeRow(record.key)}
        />
      ),
    },
  ];

  const disableAdd = !selectedItemKey || !stdQty;

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip title="Define standard material quantities per unit type">
              <h3>Define Unit Material Standard (BOM)</h3>
            </Tooltip>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Material Indent</Breadcrumb.Item>
              <Breadcrumb.Item>Unit Material Standard (BOM)</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container aidocintak">
      <div className="FormBody">
          <div className="stepscontentwrap" style={{ padding: 0 }}>
            <div className="stepsContent" style={{paddingRight:'5px'}}>
          <div className="po-good-header">
            <div className="po-header-details" style={{ margin: "0" }}>
              <div className="po-row">
                <strong>Project :</strong>
                <span>{project}</span>
              </div>
              <div className="po-row">
                <strong>Unit Type :</strong>
                <span>{unitType}</span>
              </div>
              <div className="po-row">
                <strong>Applicable For :</strong>
                <span>{applicableFor.join(", ")}</span>
              </div>
            </div>

            <Space wrap size={10}>
              <Select
                value={project}
                onChange={setProject}
                options={PROJECTS}
                style={{ width: 180 }}
                placeholder="Project"
              />
              <Select
                value={unitType}
                onChange={setUnitType}
                options={UNIT_TYPES}
                style={{ width: 200 }}
                placeholder="Unit Type"
              />
              <Select
                mode="multiple"
                value={applicableFor}
                onChange={setApplicableFor}
                options={WINGS}
                placeholder="Applicable For"
              />
            </Space>
          </div>
          <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0 }}>
                  <div className="returninfo-title">Add Items to Standard List</div>
                </Divider>
          
          <div className="po-good-header" style={{  marginTop: '5px' }}>
            <Space wrap size={10}>
              <div className="searchwrp">
                <Space direction="vertical">
                  <Search
                    placeholder="Search material item"
                    value={itemSearch}
                    onChange={(e) => setItemSearch(e.target.value)}
                    allowClear
                    prefix={
                      <img
                        src={SearchIcon}
                        alt="SearchIcon"
                        className="SearchIcon"
                        width={22}
                      />
                    }
                    style={{ width: 280 }}
                  />
                </Space>
              </div>

              <Select
                showSearch
                value={selectedItemKey}
                onChange={setSelectedItemKey}
                placeholder="Select material item"
                style={{ width: 240 }}
                options={filteredMasterItems.map((i) => ({
                  label: `${i.name} (${i.uom})`,
                  value: i.key,
                }))}
              />

              <InputNumber
                min={0}
                value={stdQty}
                onChange={setStdQty}
                style={{ width: 140 }}
                placeholder="Std Qty"
              />

              <Button disabled={disableAdd} onClick={addToList}>
                Add to List
              </Button>
            </Space>
          </div>

         
          <Divider orientation="left" plain orientationMargin={0} style={{ marginBottom: 0 }}>
                  <div className="returninfo-title">Standard Material List for {unitType}</div>
                </Divider>
          <div className="tablewrp" style={{  marginTop: '10px', marginBottom: '24px' }}>
            <Table
              rowKey="key"
              columns={columns}
              dataSource={standardList}
              pagination={false}
              scroll={{ x: 700 }}
            />
          </div>

         
        </div>
        <div className="FormFooter">
        <div className="good-tge">
        <Alert
            type="info"
            showIcon
            style={{
              width: "100%",
              padding: "5px 10px",
              borderRadius: 4,
            }}
            message="This data populates the 'Typical Requirement' field for contractor indent requests."
          />
          </div>
          
            <Button
              type="primary"
              className="SaveGradiantBtn"
              onClick={() => {
                // eslint-disable-next-line no-console
                console.log("Save Standard Definition", {
                  project,
                  unitType,
                  applicableFor,
                  standardList,
                });
              }}
            >
              Save Standard Definition
            </Button>
          </div>

         
        </div>
        </div>
      </section>
    </>
  );
};

export default UnitMaterialStandardBOM;